import React from "react";
import { Text, Flex, Circle } from "@chakra-ui/react";

type DiagramKeyProps = {
  color: string;
  label: string;
  value: string;
};

export function DiagramKey({ color, label, value }: DiagramKeyProps) {
  return (
    <Flex align="center" gap={2.5}>
      <Circle bg={color} size="10px" />
      <Text color="product.gray.500" fontWeight="medium" fontSize={{ base: "xs", lg: "sm", xl: "md" }}>
        {label}{" "}
        <Text as="span" color="product.gray.800">
          {value}
        </Text>
      </Text>
    </Flex>
  );
}
